import { defaultApplicantName } from '../../../../../../../constants';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import DebtScheduleRuleset from '../../business/ruleset/DebtScheduleRuleset';
import loanFormModel from '../../form_models/loanFormModel';

const { debtSchedule } = loanFormModel.formField.loanObligationsDocuments;

export class DebtScheduleValidation implements ValidationSchema {
  public name = debtSchedule.name;
  public label = debtSchedule.getLabel(defaultApplicantName);
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = DebtScheduleRuleset;

  public when(...args: any[]) {
    const result: RulesetResult = args.pop();
    const required = !!(result & RulesetResult.REQUIRED);

    return FileNameValidationSchema(debtSchedule.name, required);
  }
}
export default new Validation(new DebtScheduleValidation());
